import React from "react"
import PropTypes from "prop-types"

const Reset = ({ isActive }) => (
    <div>
        {isActive
            ? <svg><use xlinkHref="#cross-icon" /></svg>
            : <svg><use xlinkHref="#search-icon" /></svg>}
    </div>
)
Reset.propTypes = {
	isActive: PropTypes.bool.isRequired,
}
export default Reset